module.exports = __webpack_public_path__ + "img/line.fc96bd2b.svg";